import posthog from "posthog-js";

// In production builds, `process.env.POSTHOG_API_KEY` is replaced inline by build.ts define.
// In dev mode (bun dev), `process` doesn't exist in the browser, so guard against that.
const apiKey = typeof process !== "undefined" ? process.env.POSTHOG_API_KEY : "";

if (apiKey) {
	posthog.init(apiKey, {
		api_host: "https://us.i.posthog.com",
		autocapture: false,
	});
}

export default posthog;
